import { Patient, PhoneInfo } from '@store/patientStore';
import { GeneralInfoDTO } from '@utils/interfaces';
import React from 'react';

export const formatPhone = (
  val: PhoneInfo | undefined,
  removePrefix?: boolean,
) => {
  if (!val?.prefix || !val?.number) {
    return '';
  }

  if (removePrefix) {
    return `${val.number}`;
  }

  return `${val.prefix} ${val.number}`;
};

export const formatGeneralAddress = (
  val: GeneralInfoDTO | undefined,
  RONAformat?: boolean | undefined,
) => {
  if (val) {
    return RONAformat
      ? `${val.address.line[1]}, ${val.address.city}, ${val.address.state} ${val.address.postalCode}`
      : `${val.address.line[0]}, ${val.address.postalCode}, ${val.address.city} (${val.address.state})`;
  }
  return '';
};

export const formatPatientAddress = (
  val: Patient['patientDetails'] | undefined,
) => {
  if (!val?.streetAddress) {
    return '';
  }

  const city = val.city ? `, ${val.city}` : '';
  const stateAndZipSeparator = val.state || val.zipCode ? ', ' : '';
  const state = val.state ? `${val.state} ` : '';
  const zipCode = val.zipCode || '';

  return `${val.streetAddress}${city}${stateAndZipSeparator}${state}${zipCode}`;
};

export const formatDate = (val: string): string => {
  const date = new Date(val);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

/**
 *  Take a raw phone string and return a clickable tel: link
 */
export function phoneLink(phoneRaw?: string | null): React.ReactElement | null {
  function sanitizeTel(phoneRaw: string) {
    const firstPart = phoneRaw.split(/[/,|]/)[0].trim();
    const tel = firstPart
      .replace(/\s+/g, '')
      .replace(/[^\d+]/g, '')
      .replace(/(?!^)\+/g, '');
    return /\d/.test(tel) ? tel : null;
  }

  if (!phoneRaw) return null;

  const telNumber = sanitizeTel(phoneRaw);
  if (!telNumber) return null;

  // Mobile => link cliccabile (niente JSX)
  return React.createElement(
    'a',
    {
      href: `tel:${telNumber}`,
      style: {
        textDecoration: 'underline',
        color: 'inherit',
        fontWeight: 700,
      },
      'aria-label': phoneRaw,
    },
    phoneRaw,
  );
}

export function handlePrint() {
  const styleId = 'custom-print-style';
  const printRoot = document.getElementById('print-root');

  if (!document.getElementById(styleId)) {
    if (printRoot) {
      let current = printRoot.parentElement;
      while (current && current !== document.body) {
        current.classList.add('print-ancestor');
        current = current.parentElement;
      }
    }

    const style = document.createElement('style');
    style.id = styleId;
    style.innerHTML = `
      @media print {
        body *:not(.print-ancestor):not(#print-root):not(#print-root *) {
          display: none !important;
        }
        .print-ancestor {
          margin: 0 !important;
          padding: 0 !important;
          border: none !important;
          position: static !important;
          transform: none !important;
          overflow: visible !important;
          height: auto !important;
          min-height: 0 !important;
        }
        #print-root {
          position: absolute !important;
          left: 0 !important;
          top: 0 !important;
          width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
  window.print();

  // Pulisco le regole visive temporanee
  setTimeout(() => {
    const el = document.getElementById(styleId);
    if (el) el.remove();

    const ancestors = document.querySelectorAll('.print-ancestor');
    ancestors.forEach(a => a.classList.remove('print-ancestor'));
  }, 5000);
}
